export { SORT_TYPES } from './sortTypes';

const column = (id, label, sortType, defaultVisible = true) => ({
  id, label, alwaysVisible: false, defaultVisible, sortable: true, sortType,
});

export const GIFT_CARD_LIABILITY_COLUMNS = [
  column('product_name', 'Product', 'text'),
  column('scope_label', 'Where It Works', 'text'),
  column('cards', 'Cards With Balance', 'number'),
  column('outstanding_cents', 'Outstanding', 'currency'),
  column('paid_cents', 'Paid', 'currency'),
  column('promotional_cents', 'Promotional', 'currency'),
  column('age_0_90_cents', '0–90 Days', 'currency'),
  column('age_90_365_cents', '90–365 Days', 'currency'),
  column('age_1_3_years_cents', '1–3 Years', 'currency'),
  column('age_3_plus_years_cents', '3+ Years', 'currency'),
  column('expired_cents', 'Expired Unused', 'currency'),
];

export const GIFT_CARD_SALES_COLUMNS = [
  column('product_name', 'Product', 'text'),
  column('channel_label', 'Channel', 'text'),
  column('cards', 'Cards', 'number'),
  column('face_value_cents', 'Face Value', 'currency'),
  column('organizer_fees_cents', 'Your Fees', 'currency'),
  column('opendate_fees_cents', 'Opendate & Processing Fees', 'currency'),
  column('taxes_cents', 'Taxes', 'currency', false),
  column('refunds_cents', 'Refunded to Buyers', 'currency'),
  column('team_refunds_cents', 'Your Share of Refunds', 'currency', false),
  column('net_cents', 'Your Net', 'currency'),
];

export const GIFT_CARD_REDEMPTIONS_COLUMNS = [
  column('venue_name', 'Venue', 'text'),
  column('event_name', 'Event', 'text'),
  column('event_date', 'Event Date', 'date'),
  column('uses', 'Uses', 'number'),
  column('redeemed_cents', 'Redeemed', 'currency'),
  column('refunded_cents', 'Refunded', 'currency'),
  column('net_cents', 'Net Used', 'currency'),
];

export const GIFT_CARD_LEDGER_COLUMNS = [
  column('created_at', 'Date', 'date'),
  { ...column('code_last4', 'Card', 'text'), sortable: false },
  column('product_name', 'Product', 'text'),
  column('kind', 'Type', 'text'),
  column('amount_cents', 'Amount', 'currency'),
  column('balance_after_cents', 'Balance After', 'currency'),
  { ...column('venue_name', 'Venue', 'text'), sortable: false },
  { ...column('order_id', 'Order #', 'number', false), sortable: false },
  { ...column('note', 'Note', 'text', false), sortable: false },
];

export const defaultVisibleColumns = (columns) => () => columns.filter((c) => c.defaultVisible);

export const defaultHiddenColumns = (columns) => () => columns.filter((c) => !c.defaultVisible && !c.alwaysVisible);
